const navigateTo = (url: string): void => {
  window.location.assign(url);
};

const replaceTo = (url: string): void => {
  window.location.replace(url);
};

export { navigateTo, replaceTo };
